import React from 'react';
import PropTypes from 'prop-types';

import theme from '../../styles/theme';

import { StyledSpan } from './styles';

function Text({
  type,
  family = 'Poppins',
  weight = 400,
  color,
  transform,
  fontSize,
  as = 'span',
  clickable,
  ...props
}) {
  const styles = {
    fontFamily: family,
    fontWeight: weight,
    color: theme.colors[color] || color,
    fontSize: theme.text.sizes[type],
    textTransform: transform,
  };

  return <StyledSpan as={as} clickable={clickable} style={styles} {...props} />;
}

Text.defaultProps = {
  type: 'body',
  color: 'text',
  transform: 'none',
};

Text.propTypes = {
  type: PropTypes.oneOf(
    'title',
    'subtitle',
    'header',
    'body',
    'label',
    'little'
  ),
  color: PropTypes.string,
  transform: PropTypes.oneOf('none', 'uppercase', 'lowercase', 'capitalize'),
};

export default Text;
